module.exports = __webpack_public_path__ + "static/media/Commissioned Officers Association Logo.6a8f4dc7.jpeg";